// extracted by mini-css-extract-plugin
module.exports = {"modal":"Loader_modal__1O5N1","loader":"Loader_loader__29pBP"};